import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/app/StatusBadge";
import { useAuth } from "@/context/AuthContext";
import { own } from "@/lib/terminology";

export default function Exceptions() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/dashboard/exceptions").then(({ data }) => setItems(data.items || []));
  }, []);
  return (
    <div className="space-y-4 max-w-[1400px]">
      <div>
        <div className="text-[10px] font-semibold tracking-[0.08em] uppercase text-slate-500">{own(user, "Work")}</div>
        <h1 className="text-2xl font-heading font-semibold text-slate-900 tracking-tight">Exception Centre</h1>
        <p className="text-sm text-slate-500 mt-0.5">Actionable anomalies detected across all your assets and workflows.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-md overflow-hidden divide-y divide-slate-100">
        {items.map((e) => (
          <div key={e.type} className="flex items-center justify-between px-4 py-3 hover:bg-slate-50">
            <div>
              <div className="text-sm font-medium text-slate-900">{e.label}</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-400 mt-0.5">{e.type}</div>
            </div>
            <div className="flex items-center gap-3">
              <StatusBadge value={e.severity} />
              <div className="text-lg font-heading font-semibold text-slate-900 w-12 text-right">{e.count}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
